import { industriesData } from "@/mocks/homeData";
import AnimatedSection from "@/components/AnimatedSection";

export default function IndustriesSection() {
  return (
    <section id="solutions" className="py-20 md:py-28 bg-background-100">
      <div className="container-astro">
        <AnimatedSection>
          <div className="text-center mb-14 md:mb-18">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 mb-5 font-heading tracking-tight">
              {industriesData.heading}
            </h2>
            <div className="w-16 h-1 bg-accent-500 rounded-full mx-auto" />
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {industriesData.items.map((item, i) => (
            <AnimatedSection key={item.name} delay={i * 80}>
              <div className="group p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-accent-300/25 hover:shadow-lg hover:shadow-accent-500/5 transition-all duration-400 card-lift text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-50 text-secondary-600 mx-auto mb-3 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                  <span className="w-6 h-6 flex items-center justify-center">
                    <i className={`${item.icon} text-xl`} />
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 font-heading mb-1.5">
                  {item.name}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed max-w-[180px] mx-auto">
                  {item.desc}
                </p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}